<script setup>
import { getCurrentInstance, onMounted, ref } from 'vue'
import { XMarkIcon } from "@heroicons/vue/24/outline"
import AuctionCard from "@/Components/Auction/AuctionCard.vue"

const props = defineProps({
  auction: {
    type: Object,
    required: true
  },
})

const emit = defineEmits(['remove'])

const removeAuction = () => {
  emit('remove', props.auction.id)
}

const removable = ref(false)

onMounted(() => {
  const { vnode } = getCurrentInstance()

  if (vnode.props.hasOwnProperty('onRemove')) {
    removable.value = true
  }
})
</script>

<template>
  <div class="relative">
    <div v-if="removable" class="absolute -top-4 z-30 -left-4">
      <button
        @click.prevent="removeAuction"
        type="button"
        class="h-8 w-8 p-1.5 bg-white hover:bg-gray-200 rounded-lg border border-gray-100"
      >
        <XMarkIcon class="w-full h-full bg-transparent text-red-400" />
      </button>
    </div>
    <div class="absolute w-full h-full bg-white bg-opacity-25 flex items-center justify-center">
      <div class="bg-black py-1 px-4 rounded-full bg-opacity-50 text-white text-xs">{{ __('Preview Only') }}</div>
    </div>
    <AuctionCard :item="auction" />
  </div>
</template>
